// `signIn.social({ provider: 'google', callbackURL })` in the Next components. The Rails
// equivalent is the OmniAuth request phase, which is reached through the self-submitting
// page at GET /auth/:provider and returns to `origin` once the session is open.
export function googleSignInPath(callbackPath: string): string {
  return `/auth/google_oauth2?origin=${encodeURIComponent(callbackPath)}`;
}
